// extracted by mini-css-extract-plugin
export default {"CardBase":"card-base-module__CardBase--RNdNz"};